module.exports = __webpack_public_path__ + "static/media/SB.ea3600ae.svg";